// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7071) return "js/admin/articles/index/7071.js";
	if (chunkId === 3966) return "js/admin/articles/index/3966.js";
	if (chunkId === 1322) return "js/admin/articles/index/1322.js";
	// return url for filenames based on template
	return undefined;
};